function initLoadMore() {
  const oldBtn = document.querySelector('.load-more-btn');
  if (!oldBtn || oldBtn.dataset.initialized) return;
  
  oldBtn.dataset.initialized = 'true';

  oldBtn.addEventListener('click', function(e) {
    e.preventDefault();
    const url = oldBtn.getAttribute('href');
    oldBtn.textContent = 'Loading...';
    oldBtn.style.pointerEvents = 'none';

    fetch(url)
      .then(r => r.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        const newItems = doc.querySelectorAll('#product-grid .grid__item');
        const grid = document.querySelector('#product-grid');
        newItems.forEach(item => grid.appendChild(item));

        const nextBtn = doc.querySelector('.load-more-btn');
        const container = document.querySelector('.collection-load-more');
        if (nextBtn) {
          oldBtn.setAttribute('href', nextBtn.getAttribute('href'));
          oldBtn.textContent = 'SHOW MORE ↓';
          oldBtn.style.pointerEvents = 'auto';
          oldBtn.dataset.initialized = 'true';
        } else {
          container.style.display = 'none';
        }
      });
  });
}

// MutationObserver следит за появлением кнопки после фильтрации
const observer = new MutationObserver(function() {
  initLoadMore();
});

observer.observe(document.body, { childList: true, subtree: true });

// Также при первой загрузке
document.addEventListener('DOMContentLoaded', initLoadMore);
